module.exports = "/dist/img/giftshopper_fabric2.54e55fca.jpg";